export default "__VITE_ASSET__722fb007__"